module.exports = "/dist/assets/images/anm-ed-no-data.svg";